import { writeFileXLSX, utils } from 'xlsx';

export const downloadSearchResults = ( data, filename ) => {
    const worksheet = utils.json_to_sheet( data );
    const workbook = utils.book_new();
    utils.book_append_sheet( workbook, worksheet, 'giftcodes' );
    writeFileXLSX( workbook, filename );
};

export const downloadDepositFile = ( data, filename ) => {
    if ( navigator.msSaveBlob ) {
        data = window.atob( data );
        const byteArrays = [];
  
        for ( let offset = 0; offset < data.length; offset += 512 ) {
            const slice = data.slice( offset, offset + 512 );
            
            const byteNumbers = new Array( slice.length );
            for ( let i = 0; i < slice.length; i++ ) {
                byteNumbers[ i ] = slice.charCodeAt( i );
            }
            
            const byteArray = new Uint8Array( byteNumbers );
            
            byteArrays.push( byteArray );
        }
  
        const blob = new Blob( byteArrays, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' } );
        navigator.msSaveBlob( blob, filename );
    } else {
        const element = document.createElement( 'a' );
        element.setAttribute( 'href', 'data:text/plain;base64,' + data );
        element.setAttribute( 'download', filename );

        element.style.display = 'none';
        document.body.appendChild( element );

        element.click();

        document.body.removeChild( element );
    }

};